export default __webpack_public_path__ + "static/media/plus-sign.4f860a4e.svg";